/* =============================================================
   JMM Atelier — points des carrousels (mobile).
   Le balayage lui-même est 100 % natif (scroll-snap) ;
   ce script ne fait que synchroniser les points et permettre
   d'y naviguer au clic. Chaque bloc [data-jma-carousel] est
   autonome (photos, services, machines). Multi-instances,
   ré-init éditeur.
   ============================================================= */
(function () {
  'use strict';

  function initCarousel(box) {
    if (box.getAttribute('data-jma-init') === '1') return;
    box.setAttribute('data-jma-init', '1');

    var strip = box.querySelector('[data-jma-strip]');
    var dots = [].slice.call(box.querySelectorAll('[data-jma-dot]'));
    if (!strip || !dots.length) return;
    var slides = [].slice.call(strip.children);
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function sync() {
      if (!slides.length) return;
      var w = slides[0].offsetWidth + 10;
      var i = Math.round(strip.scrollLeft / w);
      i = Math.max(0, Math.min(slides.length - 1, i));
      dots.forEach(function (d, j) { d.classList.toggle('is-on', j === i); });
    }

    strip.addEventListener('scroll', sync, { passive: true });
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        var i = parseInt(d.getAttribute('data-jma-dot'), 10);
        if (slides[i]) slides[i].scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', inline: 'center', block: 'nearest' });
      });
    });
    sync();
  }

  function initAll() {
    document.querySelectorAll('[data-jma] [data-jma-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else { initAll(); }
  document.addEventListener('shopify:section:load', function () { window.setTimeout(initAll, 0); });
})();
